import { ChangeDetectorRef, Component, OnInit, ElementRef, Input, Output, EventEmitter, HostListener, ViewChild, TemplateRef, Renderer2 } from '@angular/core';
import { ROUTES } from '../../classes/routes';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { MatBottomSheet, MatBottomSheetConfig } from '@angular/material/bottom-sheet';
import { Router } from '@angular/router';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { UsersService } from '../../services/users.service';
import { Message } from '../../classes/message';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { interval, Subscription, Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { OrdersService } from '../../services/orders.service';
import { OmsService } from '../../services/oms.service';
import * as moment from 'moment';
import { FormBuilder, Validators, ControlContainer, FormGroupDirective, FormControl, FormGroup, UntypedFormControl, UntypedFormBuilder } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { getPrinters } from 'pdf-to-printer';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DispatchService } from 'app/services/dispatch.service';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { ClaudeService } from '../../services/claude-service.service';
import { ClaudeResponseParser } from '../../services/claude-response-parser.service';
import { getErrorMessage } from '../../services/claude-error-messages';
import { ClaudeAPIError } from '../../models/claude.types';
import { MarkdownModule } from 'ngx-markdown';
import { SystemService } from '../../services/system.service';
import { ComponentGuidanceService } from '../../services/component-guidance.service';
import { BusinessManagerComponent } from '../business-manager/business-manager.component';

declare const google: any;

@Component({
	selector: 'app-navbar',
	templateUrl: './navbar.component.html',
	styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {

	@Output() rightSidebarEvent = new EventEmitter < boolean > ();
	@ViewChild('checkedOrders') checkedOrdersTemplate = {} as TemplateRef < any > ;
	@ViewChild('pickingOrders') pickingOrdersTemplate = {} as TemplateRef < any > ;
	@ViewChild('pickedOrders') pickedOrdersTemplate = {} as TemplateRef < any > ;
	@ViewChild('sweeper') sweeperRef = {} as TemplateRef < any > ;
	@ViewChild('newOrders') newOrdersTemplate = {} as TemplateRef < any > ;
	@ViewChild('aIBottomSheet') AIBottomSheet = {} as TemplateRef < any > ;
	@ViewChild('manualBottomSheetTemplate') manualBottomSheetTemplate = {} as TemplateRef < any > ;

	@ViewChild('chartContainer', { static: false }) chartContainer!: ElementRef;

	chartInstances: any[] = [];
	loadingAi = false;
	cleanedAiText = '';

	private sort: MatSort;
	returningTruck: any;
	mapLoading = false;
	subbedToAlerts = false;
	markdownString: any = '';
	@ViewChild(MatSort) set matSort(ms: MatSort) {
		this.sort = ms;
		this.setDataSourceAttributes();
	}

	@ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {

		this.paginator = mp;
		this.setDataSourceAttributes();
	}

	setDataSourceAttributes() {
		this.dataSource.paginator = this.paginator;
	}

	dataSource: MatTableDataSource < any > ;
	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
	dataObs: Observable < any > ;

	navSubscription: Subscription
	idleState = 'NOT_STARTED';
	countdown ? : number = null;
	lastPing ? : Date = null;
	neworders: any = [];

	opened = false
	ordersopened = false

	listTitles: any[];
	location: Location;
	right_sidebar = true;
	mobile_menu_visible: any = 0;
	toggleButton: any;
	sidebarVisible: boolean;
	searchTerm = '';
	userData;
	orderData;
	searchResults;
	SENDER;
	messages = [];
	message;
	CHAT_ROOM = 'DashBoard';
	messageForm;
	messagecount = 0;
	public itcount = 0;
	sub;
	notificationcount: number;
	public collapseMini = false;
	color: any = 'blue';
	config: any = false;
	original_url: any = false;
	user: any = false;
	timer: any = false;

	pendingorders: any = [];
	allpendingorders: any = [];
	pendingopen: any = [];
	pickedorders: any = [];
	invoiceorders: any = [];
	pickingorders: any = [];
	pickopen: any = false;
	invoiceopen: any = false;
	checkopen: any = false;

	items_per_page = [10, 25, 50, 100, 500];
	pagesizedefault = 10;

	searchPending = new UntypedFormControl('');

	//truck alert & map
	@ViewChild('mapDiv') mapDivEle: ElementRef;
	@ViewChild('truckalert') truckalertRef: ElementRef;


	map: any = false;
	updated_map: any = false;
	markers: any = [false];
	pathlines: any = false;
	isMerging = false;
	map_animation: any = google.maps.Animation.DROP;


	durationInSeconds = 5;
	fetching: any = false;
	showsweeper = false;
	private ctrlPressed = false;
	private aPressed = false;

	@HostListener('document:keydown', ['$event'])
	handleKeyDown(event: KeyboardEvent): void {

		if (!event.key) {
			return;
		}

		if (event.key === 'Control') {
			this.ctrlPressed = true;
		}
		if (event.key.toLowerCase() === 'h' && this.ctrlPressed) {
			this.aPressed = true;
		}
		if (event.key.toLowerCase() === 'j' && this.ctrlPressed && this.aPressed) {
			event.preventDefault(); // Optional: prevent browser shortcuts like 'Ctrl + A'
			if (!this.showsweeper) {
				this.showsweeper = true;
				this.openMinesweeper();
			} else {
				this.showsweeper = false;
			}
		}
	}

	@HostListener('document:keyup', ['$event'])
	handleKeyUp(event: KeyboardEvent): void {
		if (!event.key) {
			return;
		}
		if (event.key === 'Control') {
			this.ctrlPressed = false;
		}
		if (event.key.toLowerCase() === 'h') {
			this.aPressed = false;
		}
	}

	aiDataAvailable: any = null;
	aiResult: any = null
	markdownManual: any = null;
	helpManualAvailable: any = null;
	loadingManual = false;
	aiAlwaysEnabled = true;
	private aiRequestSubscription ? : Subscription;
	private destroy$ = new Subject < void > ();
	private aiRequestInProgress = false;
	loadingStage = 'Initializing...';

	constructor(private renderer: Renderer2, private claudeService: ClaudeService, private claudeResponseParser: ClaudeResponseParser, private _snackBar: MatSnackBar, private dispatchService: DispatchService, private bottomSheet: MatBottomSheet, private omsService: OmsService, private modalService: NgbModal, private ordersService: OrdersService, location: Location, private element: ElementRef, private router: Router, private globalSearchService: GlobalSearchService, private usersService: UsersService, public formBuilder: UntypedFormBuilder, private idle: Idle, keepalive: Keepalive, public cd: ChangeDetectorRef, private systemService: SystemService, private componentGuidanceService: ComponentGuidanceService) {

		this.color = this.globalSearchService.getColor();
		this.location = location;


		this.globalSearchService.aiDataAvailable$.subscribe((status) => {
			this.aiDataAvailable = status;
		});

		this.globalSearchService.aiDataResults$.subscribe((response) => {
			this.aiResult = response;
		});


		this.globalSearchService.helpManualAvailable$.subscribe((response) => {
			this.helpManualAvailable = response;
		});


		this.globalSearchService.configsubscription.subscribe(conf => {
			this.config = conf;
			// this.aiAlwaysEnabled = false;
		});

		this.globalSearchService.user.subscribe(result => {
			this.user = result;
			if (this.config.package === 'beauty') {
				const data = [{ user: this.user.user.userid }];

				this.omsService.subscribeToOrderUpdates((err, data) => {
					this.loadCheckedOrders();
				});
			}

			//groups && users - phil is the user logged in on the order dashbaord tv in the office @ cornwall
			const allowed = ['11', 'PHIL', '22']
			if (this.config.env.package === 'tires' && !this.subbedToAlerts && (allowed.includes(this.user.user.user_group) || allowed.includes(this.user.user.userid))) {
				this.subbedToAlerts = true;
				this.omsService.subscribeToTruckClearAlerts(result => {
					this.showTruckReturnAlert(result.truck)
				})
			}
			//everyone else besides drivers
			if (this.config.env.package === 'tires' && (this.user.user.user_group !== '11') || this.user.user.userid === 'PHIL') {
				this.subbedToAlerts = true;
				this.omsService.subscribeToTruckClearAlerts(result => {
					const dateTime = new Date().toLocaleString();
					this.openSnackBar(`${result?.truck?.truckname} Returning | ${dateTime}`, 'Close');
				})
				this.omsService.subscribeToWillCallAlerts(result => {
					const dateTime = new Date().toLocaleString();
					this.openSnackBar(`Will call order #${result?.data?.order} for ${result?.data?.debtor} - ${result?.data?.name}  | ${dateTime}`, 'Close');
				})
			}
		});

		idle.setIdle(600); // how long can they be inactive before considered idle, in seconds
		idle.setTimeout(600); // how long can they be idle before considered timed out, in seconds
		idle.setInterrupts(DEFAULT_INTERRUPTSOURCES); // provide sources that will "interrupt" aka provide events indicating the user is active

		// do something when the user becomes idle
		idle.onIdleStart.subscribe(() => {
			this.idleState = 'IDLE';
			this.original_url = this.router.url
			this.autonav();
		});
		// do something when the user is no longer idle
		idle.onIdleEnd.subscribe(() => {
			this.idleState = 'NOT_IDLE';
			this.countdown = null;
			cd.detectChanges(); // how do i avoid this kludge?
			this.reset();
			this.router.navigate([this.original_url]);
		});

		// do something when the user has timed out
		idle.onTimeout.subscribe(() => this.idleState = 'TIMED_OUT');
		// do something as the timeout countdown does its thing
		idle.onTimeoutWarning.subscribe(seconds => this.countdown = seconds);

	}

	getComponentManualName(component: any): string {
		const name = component.constructor.name.replace('Component', '');
		// Example: CustomersGroups → customers_customers-groups
		return name
			.replace(/([a-z])([A-Z])/g, '$1_$2') // add _ before capital
			.toLowerCase();
	}

	getComponentContext(): any | null {
		try {
			if (!this.router || !this.router.url) {
				return null;
			}

			const route = this.router.url;
			const componentName = this.componentGuidanceService.getComponentFromRoute(route) || 'unknown';

			const userRole = this.user?.value?.user?.role || this.user?.user?.role || 'user';

			return {
				route: route || '',
				component: componentName,
				userRole: userRole,
				timestamp: new Date().toISOString()
			};
		} catch (error) {
			return null;
		}
	}

	openManualBottomSheet() {
		const routePath = this.router.url.split('?')[0];
		const folderKey = routePath === '/' ? 'root' : routePath.replace(/\//g, '_');

		this.markdownManual = '';
		this.loadingManual = true;
		const config = {
			hasBackdrop: true
		}

		this.globalSearchService.loadManualMarkdown(this.helpManualAvailable).subscribe({
			next: (text) => {
				this.markdownManual = text;
				this.loadingManual = false;

				this.bottomSheet.open(this.manualBottomSheetTemplate, config);
			},
			error: () => {
				this.markdownManual = `Manual not found for: ${folderKey}`;
				this.loadingManual = false;
				this.bottomSheet.open(this.manualBottomSheetTemplate, config);
			}
		});
	}

	openComponentHelp(): void {
		if (this.aiRequestInProgress) {
			return;
		}

		this.cancelAiRequest();
		const config = {
			hasBackdrop: true
		}

		const routePath = this.router.url.split('?')[0];
		const manualPath = routePath === '/' ? 'root' : routePath.replace(/\//g, '_');

		this.loadingManual = true;
		this.markdownManual = '';

		this.globalSearchService.loadManualMarkdown(manualPath).subscribe({
			next: (text) => {
				this.loadingManual = false;
				this.markdownManual = text;
				this.bottomSheet.open(this.manualBottomSheetTemplate, config);
			},
			error: () => {
				this.loadingManual = false;
				this.markdownManual = `Manual not found for: ${manualPath}`;
				this.bottomSheet.open(this.manualBottomSheetTemplate, config);
			}
		});
	}

	private requestAIHelp(manualPath: string, config: any): void {
		this.loadingAi = true;
		this.loadingStage = 'Generating help...';
		this.bottomSheet.open(this.AIBottomSheet, config);

		const componentContext = this.getComponentContext();
		const componentName = componentContext?.component || 'unknown';

		const guidancePayload = componentContext ? {
			_context: {
				component: componentName,
				route: componentContext.route || '',
				userRole: componentContext.userRole || 'user',
				reportType: 'component_guidance',
				guidanceRequest: true,
				manualPath: manualPath
			}
		} : {
			_context: {
				component: 'unknown',
				route: this.router.url || '',
				userRole: this.user?.user?.role || 'user',
				reportType: 'component_guidance',
				guidanceRequest: true,
				manualPath: manualPath
			}
		};

		this.aiRequestInProgress = true;

		this.aiRequestSubscription = this.claudeService.analyzeReport(guidancePayload, 'component_guidance')
			.pipe(takeUntil(this.destroy$))
			.subscribe({
				next: (response) => {
					this.loadingStage = 'Processing response...';

					try {
						const parsed = this.claudeResponseParser.parseResponse(response);

						this.loadingStage = 'Finalizing...';

						this.aiResult = {
							id: `msg_${Date.now()}`,
							type: 'message',
							role: 'assistant',
							model: 'claude-3-5-sonnet-20241022',
							content: [{ type: 'text', text: parsed.text }],
							stop_reason: 'end_turn',
							stop_sequence: null,
							usage: parsed.usage || {
								input_tokens: 0,
								cache_creation_input_tokens: 0,
								cache_read_input_tokens: 0,
								output_tokens: parsed.text.length
							}
						};

						this.updateAiResult(this.aiResult);
						this.loadingAi = false;
						this.aiRequestInProgress = false;
					} catch (error) {
						this.loadingAi = false;
						this.aiRequestInProgress = false;

						if (error instanceof ClaudeAPIError) {
							const errorMessage = getErrorMessage(error.error.type, error.error.message);
							this.aiResult = {
								id: `msg_${Date.now()}`,
								type: 'message',
								role: 'assistant',
								content: [{ type: 'text', text: errorMessage }]
							};
						} else {
							console.error('Failed to parse Claude response:', error);
							this.aiResult = {
								id: `msg_${Date.now()}`,
								type: 'message',
								role: 'assistant',
								content: [{ type: 'text', text: getErrorMessage('GENERIC', error?.message) }]
							};
						}
					}
				},
				error: (err) => {
					this.loadingAi = false;
					this.aiRequestInProgress = false;
					console.error('Component Help Error:', err);

					let errorMessage = getErrorMessage('GENERIC');
					if (err?.error?.type) {
						errorMessage = getErrorMessage(err.error.type, err.error.message);
					} else if (err?.status === 0) {
						errorMessage = getErrorMessage('NETWORK_ERROR');
					} else if (err?.status === 408 || err?.name === 'TimeoutError') {
						errorMessage = getErrorMessage('TIMEOUT');
					}

					this.aiResult = {
						id: `msg_${Date.now()}`,
						type: 'message',
						role: 'assistant',
						content: [{ type: 'text', text: errorMessage }]
					};
				}
			});
	}

	openSnackBar(message: string, action: string) {
		this._snackBar.open(message, action, {
			duration: 15000
		});
	}

	/**
	 * Safely parse JSON data that might be a string or already an array/object
	 * Handles MySQL JSON columns that may return arrays directly
	 */
	private safeJsonParseNotice(value: any, defaultValue: any = []): any {
		if (value === null || value === undefined || value === '') {
			return defaultValue;
		}

		// If already an array or object, return as-is
		if (Array.isArray(value) || (typeof value === 'object' && value !== null)) {
			return value;
		}

		// If it's a string, try to parse it
		if (typeof value === 'string') {
			try {
				return JSON.parse(value);
			} catch (e) {
				console.warn('Failed to parse JSON in notice:', value, e);
				return defaultValue;
			}
		}

		return defaultValue;
	}

	private showNoticeQueue(notices: any[]) {
		if (!notices.length) {
			return;
		}
		const notice = notices.shift();
		const ref = this._snackBar.open(notice.message, 'Close', {
			horizontalPosition: 'right',
			verticalPosition: 'top',
			duration: 0
		});
		ref.afterDismissed().subscribe(() => {
			this.showNoticeQueue(notices);
		});
	}

	orderInNewOrder(data: any) {
		const thisorderexits = this.neworders.filter((a: any) => {
			return a.orderno == data.orderno;
		});
		return thisorderexits[0];
	}

	togglePickedOrders() {
		if (!this.pickopen) {
			this.pickopen = true;
			const config = {
				hasBackdrop: true
			}
			this.bottomSheet.open(this.pickedOrdersTemplate, config);
		} else {
			this.pickopen = false;
			this.bottomSheet.dismiss(this.pickedOrdersTemplate);
		}
	}

	togglePickingOrders() {
		if (!this.pickopen) {
			this.pickopen = true;
			const config = {
				hasBackdrop: true
			}
			this.bottomSheet.open(this.pickingOrdersTemplate, config);
		} else {
			this.pickopen = false;
			this.bottomSheet.dismiss(this.pickingOrdersTemplate);
		}
	}

	toggleCheckedOrders() {
		if (!this.checkopen) {
			this.checkopen = true;
			const config = {
				hasBackdrop: true
			}
			this.bottomSheet.open(this.checkedOrdersTemplate, config);
		} else {
			this.checkopen = false;
			this.bottomSheet.dismiss(this.checkedOrdersTemplate);
		}
	}

	toggleNewOrders() {
		if (!this.ordersopened) {
			this.ordersopened = true;
			const config = {
				hasBackdrop: true
			}
			this.bottomSheet.open(this.newOrdersTemplate, config);
		} else {
			this.ordersopened = false;
			this.bottomSheet.dismiss(this.newOrdersTemplate);
		}
	}

	toggleBottomSheet() {
		if (!this.opened) {
			this.opened = true;
			const config = {
				hasBackdrop: true
			}
			this.bottomSheet.open(this.checkedOrdersTemplate, config);
		} else {
			this.opened = false;
			this.bottomSheet.dismiss(this.checkedOrdersTemplate);
		}
	}

	vibrate() {
		if (window.navigator && window.navigator.vibrate) {
			navigator.vibrate(2000);
		} else {
			// Not supported
		}
	}

	getColor() {
		return this.color;
	}

	resetNewOrders() {
		this.neworders = [];
		this.bottomSheet.dismiss(this.newOrdersTemplate);
	}

	closeBottomSheet() {
		this.aiResult = false;
		this.bottomSheet.dismiss(this.checkedOrdersTemplate);
	}

	autonav() {

		if (this.idleState == 'IDLE') {
			if (this.user && this.user.user.user_group == '21') {
				const cur_route = this.router.url.toUpperCase();

				this.navSubscription = interval(150).subscribe((x => {
					if (cur_route.length && !cur_route.includes('STICKER')) { //don't rotate display if in sticker components
						this.rotateNav();
					}
				}));
			} else {
				const d = new Date();
				const hour = d.getHours();
				if (hour > 20) {
					this.reset();
					//this.router.navigate(['auth/logout']);
					location.reload()
				}
			}
		}
	}

	rotateNav() {

		const navoptions = [
			'warehouse/warehouse-reports',
			'dashboard',
		]

		if (this.itcount == navoptions.length - 1) {
			this.itcount = 0;
		}

		const newroute = navoptions[this.itcount];
		if (this.user) {
			this.router.navigate([newroute]);
			this.itcount = this.itcount + 1
		}

		if (
			this.router.url != '/orders/entry' &&
			this.router.url != '/inventory/lookup' &&
			this.router.url != '/dispatches/route' &&
			this.router.url != '/orders/pick'

		) {

			if (this.sidebarVisible) {
				//	this.sidebarToggle();
				//	this.collapseMini = false;
				//	this.miniSideBar()
			}

			//this.router.navigate([newroute]);
		} else {
			//not allowed here.
		}

	}

	keyPress(event: KeyboardEvent): void {
		this.reset();
	}

	@HostListener('document:mousemove', ['$event'])
	onMouseMove(e) {
		this.reset();
	}

	reset() {
		// we'll call this method when we want to start/reset the idle process
		// reset any component state and be sure to call idle.watch()
		this.idle.watch();
		this.idleState = 'NOT_IDLE';
		this.countdown = null;
		this.lastPing = null;
		if (this.navSubscription) {
			this.navSubscription.unsubscribe();
		}



	}

	ngOnInit() {

		this.reset();
		this.setPagination([]);

		this.userData = this.usersService.getLocalUser();

		this.globalSearchService.messages.subscribe((results: any) => {
			this.messagecount = results;
		});

		this.globalSearchService.searchTerm.subscribe((newValue: any) => {
			this.searchTerm = newValue;
		});

		this.globalSearchService.userData.subscribe((newValue: any) => {
			this.userData = newValue;
			this.user = newValue;
			//this.loadCheckedOrders();
		});

		this.globalSearchService.searchResults.subscribe((newValue: any) => {
			this.searchResults = newValue;
		});

		this.listTitles = ROUTES.filter(listTitle => listTitle);

		this.listTitles.forEach(a => {
			if (a.children) {
				a.children.forEach(b => {
					if (this.listTitles.indexOf(b) < 1) {
						this.listTitles.push(b);
					}
				})
			}
		});

		const navbar: HTMLElement = this.element.nativeElement;
		this.toggleButton = navbar.getElementsByClassName('navbar-toggler')[0];
		this.router.events.subscribe((event) => {
			this.sidebarClose();
			const $layer: any = document.getElementsByClassName('close-layer')[0];
			if ($layer) {
				$layer.remove();
				this.mobile_menu_visible = 0;
			}
		});

		const navstate = this.usersService.getNavState();
		if (navstate) {
			this.collapseMini = false;
			this.miniSideBar();
		}


		this.loadCheckedOrders();

		this.systemService.getSystemNotice().subscribe({
			next: (notices: any) => {
				if (Array.isArray(notices) && notices.length) {
					try {
						// Safely parse groups and locations if they're strings
						const processedNotices = notices.map((n: any) => ({
							...n,
							groups: this.safeJsonParseNotice(n.groups),
							locations: this.safeJsonParseNotice(n.locations)
						}));
						const sorted = processedNotices.sort((a, b) => (b.priority || 0) - (a.priority || 0));
						this.showNoticeQueue(sorted);
					} catch (error) {
						console.error('Error processing notices in navbar:', error);
					}
				}
			},
			error: (error: any) => {
				console.error('Error loading system notices in navbar:', error);
				// Silently fail in navbar - don't show error to user for notices
			}
		});

	}

	audioPlayNewOrder() {

		//var audio = new Audio("/assets/out-of-nowhere-message-tone.mp3");
		//let play = audio.play();
		// if (play !== undefined) {
		// 	play.catch(error => {
		// 		// Auto-play was prevented
		// 		// Show a UI element to let the user manually start playback
		// 	}).then(() => {
		// 		// Auto-play started
		// 	});
		// }
	}



	loadCheckedOrders() {
		// Setup search parameters with direct default location assignment
		const search = {
			loccode: this.user?.user.defaultlocation.loccode || '',
			debtorno: false,
			newonly: true,
		};

		// Cancel any active subscription
		if (this.fetching) {
			this.fetching?.unsubscribe();
		}

		// Process orders in a single-pass reduce function
		this.fetching = this.ordersService.getCustomerOpenOrdersFiltered(search).subscribe({
			next: (results: any) => {
				if (results && results.length) {
					const categorizedOrders = results.reduce(
						(acc, order) => {
							const orderStatusId = parseInt(order.orderstatusid, 10);

							if (order.placedfrom === '3' || order.placedfrom === '4') {
								switch (true) {
									case orderStatusId === 1:
										acc.pendingorders.push(order);
										break;
									case orderStatusId >= 5 && orderStatusId < 21:
										acc.pickingorders.push(order);
										break;
									case orderStatusId === 21:
										acc.pickedorders.push(order);
										break;
									case orderStatusId === 24:
										acc.invoiceorders.push(order);
										break;
								}
							}
							return acc;
						}, { pendingorders: [], pickingorders: [], pickedorders: [], invoiceorders: [] }
					);

					this.pendingorders = categorizedOrders.pendingorders;
					this.allpendingorders = categorizedOrders.pendingorders;
					this.setPagination(this.pendingorders);

					this.pickingorders = categorizedOrders.pickingorders;
					this.pickedorders = categorizedOrders.pickedorders;
					this.invoiceorders = categorizedOrders.invoiceorders;
				}
			},
			error: (err: any) => {
				const msg = err?.error?.message ?? err?.message ?? (typeof err === 'object' && err !== null ? JSON.stringify(err) : err);
				const status = err?.status ?? err?.statusCode;
				console.error('Failed to load customer open orders:', status ? `[${status}]` : '', msg || err);
			}
		});
	}



	loadOrder(orderno: any) {
		this.globalSearchService.reloadingOrder(true);
		this.ordersService.loadSalesOrder(orderno).subscribe({
			next: (result: any) => {
				this.router.navigate(['./orders/entry/' + result.header.debtorno + '/' + result.header.branchcode]);
				this.globalSearchService.reloadingOrder(false);
				this.spliceandCloseNewOrder(orderno);
			},
			error: (err) => {
				this.globalSearchService.reloadingOrder(false);
				console.error('Failed to load order:', err);
			}
		});
	}

	spliceandCloseNewOrder(orderno: any) {
		//REMOVED New orders - made more sense for pending
		if (!this.neworders.length) {
			this.bottomSheet.dismiss(this.newOrdersTemplate);
		} else {
			//not sure if this is wanted. place holder
			this.bottomSheet.dismiss(this.newOrdersTemplate);
		}
	}

	selectItemLookup(event: any) {
		this.router.navigate(['./customers/view/' + event.debtorno]);
	}

	pickOrder(event: any) {
		this.bottomSheet.dismiss()
		this.router.navigate(['./orders/pick/' + event]);
	}

	checkOrder(event: any) {
		this.bottomSheet.dismiss()
		this.router.navigate(['./orders/check/' + event]);
	}

	invoiceOrder(event: any) {
		this.bottomSheet.dismiss()
		this.router.navigate(['orders/invoice/' + event + '/dispatch']);
	}

	sidebarOpen() {
		const toggleButton = this.toggleButton;
		const body = document.getElementsByTagName('body')[0];
		setTimeout(function() {
			toggleButton.classList.add('toggled');
		}, 500);

		body.classList.add('nav-open');

		this.sidebarVisible = true;
	};

	sidebarClose() {
		const body = document.getElementsByTagName('body')[0];
		this.toggleButton.classList.remove('toggled');
		this.sidebarVisible = false;
		body.classList.remove('nav-open');
	};

	sidebarToggle() {
		// const toggleButton = this.toggleButton;
		// const body = document.getElementsByTagName('body')[0];
		const $toggle = document.getElementsByClassName('navbar-toggler')[0];
		//this.usersService.setNavState(this.sidebarVisible)

		if (this.sidebarVisible === false) {
			this.sidebarOpen();
		} else {
			this.sidebarClose();
		}
		const body = document.getElementsByTagName('body')[0];

		if (this.mobile_menu_visible == 1) {
			// $('html').removeClass('nav-open');
			body.classList.remove('nav-open');
			if ($layer) {
				$layer.remove();
			}
			setTimeout(function() {
				$toggle.classList.remove('toggled');
			}, 400);

			this.mobile_menu_visible = 0;
		} else {
			setTimeout(function() {
				$toggle.classList.add('toggled');
			}, 430);

			var $layer = document.createElement('div');
			$layer.setAttribute('class', 'close-layer');

			if (body.querySelectorAll('.main-panel')) {
				document.getElementsByClassName('main-panel')[0].appendChild($layer);
			} else if (body.classList.contains('off-canvas-sidebar')) {
				document.getElementsByClassName('wrapper-full-page')[0].appendChild($layer);
			}

			setTimeout(function() {
				$layer.classList.add('visible');
			}, 100);

			$layer.onclick = function() { //asign a function
				body.classList.remove('nav-open');
				this.mobile_menu_visible = 0;
				$layer.classList.remove('visible');
				setTimeout(function() {
					$layer.remove();
					$toggle.classList.remove('toggled');
				}, 400);
			}.bind(this);

			body.classList.add('nav-open');
			this.mobile_menu_visible = 1;
		}
	};

	getTitle() {

		let titlee = this.location.prepareExternalUrl(this.location.path());
		if (titlee.charAt(0) === '#') {
			titlee = titlee.slice(1);
		}
		if (this.listTitles) {
			for (let item = 0; item < this.listTitles.length; item++) {
				if (this.listTitles[item].path === this.router.url) {
					return this.listTitles[item].title;
				}
			}
		}

		const subpath = titlee.split('/', 3);

		return this.capitalize(subpath)

		return 'Dashboard';
	}

	public capitalize(s) {

		let fullstring = '';
		s.forEach(function(value) {
			fullstring += value && value[0].toUpperCase() + value.slice(1) + ' ';
		});

		return fullstring;
	}

	public miniSideBar() {
		const body = document.getElementsByTagName('body')[0];

		if (this.collapseMini) {
			this.collapseMini = false;
			body.classList.remove('sidebar-mini');
		} else {
			this.collapseMini = true;
			body.classList.add('sidebar-mini');
		}

		this.usersService.setNavState(this.collapseMini);
	}

	public onInput(event: any) {
		// this pushes the input value into the service's Observable.
		this.globalSearchService.searchTerm.next(event.target.value);
	}

	right_side_bar() {
		this.right_sidebar = !this.right_sidebar
		this.rightSidebarEvent.emit(this.right_sidebar)
	}

	setPagination(tableData) {
		this.dataSource = new MatTableDataSource < any > (tableData);
		this.cd.detectChanges();
		this.dataSource.paginator = this.paginator;
		this.dataObs = this.dataSource.connect();
	}

	searchOpenOrders(event: any) {
		if (event != '') {
			this.pendingorders = this.globalSearchService.filterItem(this.allpendingorders, event, 'orderno,deliverto,debtorno,deladdress1,deladdress3');
			this.setPagination(this.pendingorders);
		} else {
			this.pendingorders = this.allpendingorders;
			this.setPagination(this.pendingorders);
		}
	}

	resetCount() {
		this.messagecount = 0;
	}

	closeMineSweeper(): void {
		this.bottomSheet.dismiss(this.sweeperRef);
	}

	openMinesweeper(): void {
		const config = {
			hasBackdrop: true
		}

		this.bottomSheet.open(this.sweeperRef, config);
	}

	showTruckReturnAlert(data) {
		this.returningTruck = data;
		this.dispatchService.getActiveDispatches().subscribe({
			next: (res: any) => {
				if (res && !res['drivers']?.includes(this.user?.user?.userid)) {
					this.modalService.open(this.truckalertRef, { ariaLabelledBy: 'modal-title', size: 'xl', backdropClass: 'interrupt', backdrop: 'static', keyboard: false, centered: true, windowClass: 'interrupt' }).result.then(() => {}, () => {});
					this.mapLoading = true;
					setTimeout(() => this.drawMap(data), 2500);
				}
			},
			error: (err) => console.error('Failed to load active dispatches:', err)
		});
	}

	drawMap(truck) {

		this.globalSearchService.hideSideBar();
		const coordinates = [];
		const lat = truck.lat;
		const lng = truck.lng;
		const truckname = truck.truckname;
		//bfdsc
		const home = { lat: 42.928455044944165, lng: -78.82142723259965 }
		const truckpos = { lat: Number(lat), lng: Number(lng) }
		const trucklat = new google.maps.LatLng(truckpos);
		const lines = [trucklat];
		lines.push(home)

		const m = new google.maps.Marker({
			position: home,
			title: 'BFDSC',
			optimized: true,
			animation: google.maps.Animation.DROP,
			label: {
				text: 'BFDSC',
				color: '#000',
				fontSize: '14px',
				fontWeight: 'bold'
			}
		}, );

		coordinates.push(m);

		const c = new google.maps.Marker({
			position: trucklat,
			title: truckname,
			optimized: true,
			animation: google.maps.Animation.DROP,
			label: {
				text: truckname,
				color: '#000',
				fontSize: '14px',
				fontWeight: 'bold'
			}
		});

		coordinates.push(c);

		const mapOptions = {
			zoom: 11,
			center: truckpos,
			scrollwheel: false, //we disable de scroll over the map, it is a really annoing when you scroll through page
			styles: [{
				'featureType': 'water',
				'stylers': [{
					'saturation': 43
				}, {
					'lightness': -11
				}, {
					'hue': '#0088ff'
				}]
			}, {
				'featureType': 'road',
				'elementType': 'geometry.fill',
				'stylers': [{
					'hue': '#ff0000'
				}, {
					'saturation': -100
				}, {
					'lightness': 99
				}]
			}, {
				'featureType': 'road',
				'elementType': 'geometry.stroke',
				'stylers': [{
					'color': '#808080'
				}, {
					'lightness': 54
				}]
			}, {
				'featureType': 'landscape.man_made',
				'elementType': 'geometry.fill',
				'stylers': [{
					'color': '#ece2d9'
				}]
			}, {
				'featureType': 'poi.park',
				'elementType': 'geometry.fill',
				'stylers': [{
					'color': '#ccdca1'
				}]
			}, {
				'featureType': 'road',
				'elementType': 'labels.text.fill',
				'stylers': [{
					'color': '#767676'
				}]
			}, {
				'featureType': 'road',
				'elementType': 'labels.text.stroke',
				'stylers': [{
					'color': '#ffffff'
				}]
			}, {
				'featureType': 'poi',
				'stylers': [{
					'visibility': 'off'
				}]
			}, {
				'featureType': 'landscape.natural',
				'elementType': 'geometry.fill',
				'stylers': [{
					'visibility': 'on'
				}, {
					'color': '#b8cb93'
				}]
			}, {
				'featureType': 'poi.park',
				'stylers': [{
					'visibility': 'on'
				}]
			}, {
				'featureType': 'poi.sports_complex',
				'stylers': [{
					'visibility': 'on'
				}]
			}, {
				'featureType': 'poi.medical',
				'stylers': [{
					'visibility': 'on'
				}]
			}, {
				'featureType': 'poi.business',
				'stylers': [{
					'visibility': 'simplified'
				}]
			}]

		};

		this.map = new google.maps.Map(document.getElementById('map'), mapOptions);

		coordinates.forEach((item: any) => {
			item.setMap(this.map);
		});

		const lineSymbol = {
			path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
		};

		const pathTo = new google.maps.Polyline({
			path: lines,
			geodesic: true,
			strokeColor: '#F1575A',
			strokeOpacity: 1.0,
			strokeWeight: 2,
			icons: [{
				icon: lineSymbol,
				offset: '100%'
			}],
		});

		pathTo.setMap(this.map);
		this.mapLoading = false;
	}

	formatText(text: string): string {
		// Remove [CHART_START]...[CHART_END] blocks
		text = text.replace(/\[CHART_START\][\s\S]*?\[CHART_END\]/g, '');

		// Apply formatting rules
		text = text.replace(/\*(.*?)\*/g, '<strong>$1</strong>'); // Bold text
		text = text.replace(/\n/g, '<br>'); // Line breaks
		text = text.replace(/•/g, '•'); // Bullet points
		text = text.replace(/(\d+)\.\s/g, '<span class="numbered-point">$1.</span> '); // Numbered lists
		text = text.replace(/```([\s\S]*?)```/, '<pre class="ascii-chart">$1</pre>'); // ASCII charts
		text = text.replace(/(Contact.*?:\s*)(\d{3}-\d{3}-\d{4})/g, '$1<a href="tel:$2">$2</a>'); // Phone links

		return text.trim();
	}



	closeAi() {
		this.cancelAiRequest();
		this.bottomSheet.dismiss(this.AIBottomSheet);
		this.aiResult = null;
		this.loadingAi = false;
		this.loadingStage = 'Initializing...';
	}

	private cancelAiRequest() {
		if (this.aiRequestSubscription) {
			this.aiRequestSubscription.unsubscribe();
			this.aiRequestSubscription = undefined;
		}
		this.aiRequestInProgress = false;
	}

	processAiResponse(): void {
		if (!this.aiResult || !this.aiResult.content) {
			this.cleanedAiText = '';
			return;
		}

		const fullText = this.aiResult.content
			.filter((item: any) => item.type === 'text')
			.map((item: any) => item.text)
			.join('\n\n');

		this.cleanedAiText = this.cleanText(fullText);
	}

	cleanText(text: string): string {
		return text
			.replace(/\[CHART_DATA_FOLLOWS\]/g, '')
			.replace(/\[CHART_START\][\s\S]*?\[CHART_END\]/g, '')
			.trim();
	}

	updateAiResult(newResult: any): void {
		this.aiResult = newResult;
		this.processAiResponse();
		if (this.containsChart(newResult)) {

			setTimeout(() => this.extractAndRenderCharts(), 100);
		}
	}

	openBusinessManager(): void {
		this.modalService.open(BusinessManagerComponent, { size: 'xl', centered: true, scrollable: true });
	}

	openAIBottomSheet(): void {
		if (this.aiRequestInProgress) {
			return;
		}

		this.cancelAiRequest();
		this.loadingAi = true;
		this.loadingStage = 'Initializing...';

		const config = {
			hasBackdrop: true
		}

		this.bottomSheet.open(this.AIBottomSheet, config);

		const currentData = this.globalSearchService.aiDataAvailable$.value;
		const currentContext = this.globalSearchService.aiDataContext$.value;

		//const componentContext = this.getComponentContext();
		// const enhancedPayload = currentData ? {
		// 	...currentData,
		// 	...(componentContext && {
		// 		_context: {
		// 			component: componentContext.component || 'unknown',
		// 			route: componentContext.route || '',
		// 			userRole: componentContext.userRole || 'user',
		// 			reportType: currentContext || '',
		// 			guidanceRequest: false
		// 		}
		// 	})
		// } : currentData;

		const payloadToSend = currentData;

		if (!payloadToSend) {
			this.loadingAi = false;
			this.aiResult = {
				id: `msg_${Date.now()}`,
				type: 'message',
				role: 'assistant',
				content: [{ type: 'text', text: 'No data available to analyze. Please navigate to a page with data (inventory, customer, etc.) to use AI analysis.' }]
			};
			return;
		}

		if (payloadToSend && !this.aiResult) {
			this.loadingStage = 'Sending request...';
			this.aiRequestInProgress = true;

			console.log(currentContext);



			this.aiRequestSubscription = this.claudeService.analyzeReport(payloadToSend, currentContext)
				.pipe(takeUntil(this.destroy$))
				.subscribe({
					next: (response) => {
						this.loadingStage = 'Processing response...';

						try {
							const parsed = this.claudeResponseParser.parseResponse(response);

							this.loadingStage = 'Finalizing...';

							this.aiResult = {
								id: `msg_${Date.now()}`,
								type: 'message',
								role: 'assistant',
								model: 'claude-3-5-sonnet-20241022',
								content: [{ type: 'text', text: parsed.text }],
								stop_reason: 'end_turn',
								stop_sequence: null,
								usage: parsed.usage || {
									input_tokens: 0,
									cache_creation_input_tokens: 0,
									cache_read_input_tokens: 0,
									output_tokens: parsed.text.length
								}
							};

							this.updateAiResult(this.aiResult);
							this.loadingAi = false;
							this.aiRequestInProgress = false;
						} catch (error) {
							this.loadingAi = false;
							this.aiRequestInProgress = false;

							if (error instanceof ClaudeAPIError) {
								const errorMessage = getErrorMessage(error.error.type, error.error.message);
								this.aiResult = {
									id: `msg_${Date.now()}`,
									type: 'message',
									role: 'assistant',
									content: [{ type: 'text', text: errorMessage }]
								};
							} else {
								console.error('Failed to parse Claude response:', error);
								this.aiResult = {
									id: `msg_${Date.now()}`,
									type: 'message',
									role: 'assistant',
									content: [{ type: 'text', text: getErrorMessage('GENERIC', error?.message) }]
								};
							}
						}
					},
					error: (err) => {
						this.loadingAi = false;
						this.aiRequestInProgress = false;
						console.error('AI Request Error:', err);

						let errorMessage = getErrorMessage('GENERIC');
						if (err?.error?.type) {
							errorMessage = getErrorMessage(err.error.type, err.error.message);
						} else if (err?.status === 0) {
							errorMessage = getErrorMessage('NETWORK_ERROR');
						} else if (err?.status === 408 || err?.name === 'TimeoutError') {
							errorMessage = getErrorMessage('TIMEOUT');
						}

						this.aiResult = {
							id: `msg_${Date.now()}`,
							type: 'message',
							role: 'assistant',
							content: [{ type: 'text', text: errorMessage }]
						};
					}
				});
		}
	}

	containsChart(result: any): boolean {
		if (!result || !result.content) { return false; }

		return result.content.some((item: any) => /\[CHART_START\]/.test(item.text));
	}


	async extractAndRenderCharts (): Promise < void > {
		if (!this.containsChart(this.aiResult)) {
			return;
		}

		this.destroyCharts();

		if (!this.chartContainer || !this.chartContainer.nativeElement) {
			return;
		}

		try {
			const ChartModule = await import('chart.js/auto');
			const Chart = ChartModule.Chart;

			let ChartDataLabels: any = null;
			try {
				const datalabelsModule = await import('chartjs-plugin-datalabels');
				ChartDataLabels = datalabelsModule.default || datalabelsModule;
			} catch (e) {}

			if (Array.isArray(ChartModule.registerables)) {
				Chart.register(...ChartModule.registerables);
			} else {
				Chart.register(ChartModule.registerables as any);
			}
			if (ChartDataLabels) {
				Chart.register(ChartDataLabels);
			}

			const chartMatches = this.aiResult.content
				.map((item: any) => item.text.match(/\[CHART_START\]([\s\S]*?)\[CHART_END\]/g))
				.flat()
				.filter(Boolean);

			chartMatches.forEach(chartText => {
				const chartInfo = this.parseChartMetadata(chartText);
				if (!chartInfo) { return; }

				const newCanvas = this.renderer.createElement('canvas');
				newCanvas.id = chartInfo.id;

				const chartWrapper = this.renderer.createElement('div');
				this.renderer.setStyle(chartWrapper, 'width', '100%');
				this.renderer.setStyle(chartWrapper, 'height', '400px');
				this.renderer.setStyle(chartWrapper, 'max-height', '500px');
				this.renderer.setStyle(chartWrapper, 'position', 'relative');

				this.renderer.appendChild(chartWrapper, newCanvas);
				this.renderer.appendChild(this.chartContainer.nativeElement, chartWrapper);

				const ctx = newCanvas.getContext('2d');

				newCanvas.style.height = '100%';
				newCanvas.style.width = '100%';

				const newChart = new Chart(ctx, {
					type: chartInfo.type,
					data: {
						labels: chartInfo.labels,
						datasets: [{
							label: chartInfo.series,
							data: chartInfo.values,
							backgroundColor: this.getRandomColors(chartInfo.values.length),
							borderColor: '#666',
							borderWidth: 1
						}]
					},
					options: {
						responsive: true,
						maintainAspectRatio: false,
						layout: {
							padding: { top: 10, bottom: 10 }
						},
						scales: {
							x: {
								ticks: {
									color: '#f0f0f0'
								},
								title: {
									color: '#f0f0f0'
								}
							},
							y: {
								beginAtZero: true,
								ticks: {
									color: '#f0f0f0'
								},
								title: {
									color: '#f0f0f0'
								}
							}
						},
						plugins: {
							legend: {
								position: 'bottom',
								labels: {
									color: '#f0f0f0'
								}
							},
							tooltip: {
								bodyColor: '#f0f0f0',
								titleColor: '#ffffff'
							},
							datalabels: {
								color: '#f0f0f0'
							}
						}
					}
				});

				this.chartInstances.push(newChart);
			});
		} catch (error) {
			console.error('Failed to load Chart.js:', error);
		}
	}


	parseChartMetadata(chartText: string): any {
		const idMatch = chartText.match(/id:\s*(.+)/);
		const typeMatch = chartText.match(/type:\s*(.+)/);
		const labelsMatch = chartText.match(/labels:\s*(.+)/);
		const valuesMatch = chartText.match(/values:\s*(.+)/);
		const seriesMatch = chartText.match(/series:\s*(.+)/);

		if (!idMatch || !typeMatch || !labelsMatch || !valuesMatch || !seriesMatch) { return null; }

		return {
			id: idMatch[1].trim(),
			type: typeMatch[1].trim(),
			labels: labelsMatch[1].split(',').map(label => label.trim()),
			values: valuesMatch[1].split(',').map(value => parseFloat(value)), // Ensure numeric values
			series: seriesMatch[1].trim()
		};
	}

	getChartType(chartId: string): string {
		if (chartId.includes('Sales') || chartId.includes('Performance')) { return 'line'; }
		if (chartId.includes('brandSales')) { return 'bar'; }
		if (chartId.includes('brandChart')) { return 'pie'; } // Detect pie charts
		return 'bar'; // Default to bar chart
	}

	getRandomColors(count: number): string[] {
		const colors = ['#ff5f6d', '#ff9966', '#4caf50', '#3f51b5', '#ffeb3b', '#9c27b0', '#ff5722'];
		return Array.from({ length: count }, (_, i) => colors[i % colors.length]);
	}


	destroyCharts(): void {
		this.chartInstances.forEach(chart => chart.destroy());
		this.chartInstances = [];
	}

	ngOnDestroy() {
		this.cancelAiRequest();
		this.destroy$.next();
		this.destroy$.complete();
	}
}